import Storage from 'disco-storage'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import DocumentHeadTags from 'components/document-head-tags'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import DiscoModal from 'components/ui/disco-modal'
import InlineLink from 'components/ui/inline-link'

const BulkUploaderPage = () => {
  const navigate = useNavigate()
  const title = 'Bulk Uploader | DISCO'
  const [disableMessage, setDisableMessage] = React.useState(false)
  React.useEffect(() => {
    const loadValue = async () => {
      const storageValue = await Storage.get('oneClickUploaderLaunch')
      setDisableMessage(storageValue)
    }

    loadValue()
  }, [])

  const savePreferences = async (e: React.SyntheticEvent<any>) => {
    e.preventDefault()
    const handle = window.onbeforeunload
    window.onbeforeunload = null
    window.open('discoup://launch', '_self')
    setTimeout(() => {
      window.onbeforeunload = handle
    }, 100)
    if ((await Storage.get('oneClickUploaderLaunch')) !== disableMessage)
      Storage.set('oneClickUploaderLaunch', disableMessage)
    navigate('/')
  }

  return (
    <DiscoModal contentLabel={title} onRequestClose={() => navigate('/')}>
      <DocumentHeadTags title={title} />
      <div className="Dialog">
        <h1 className="Form_Header">Bulk uploader</h1>
        <div>
          The DISCO Bulk Uploader is required for bulk uploads. Haven&#39;t
          installed the Uploader?{' '}
          <InlineLink
            target="_blank"
            rel="noopener noreferrer"
            to={`${DISCO_SITE}/downloads`}
          >
            Get it here.
          </InlineLink>
        </div>
        <DialogFooter
          corner={
            <label className="Dialog_CancelLabel!">
              <input
                type="checkbox"
                className="Form_checkbox"
                checked={disableMessage}
                onChange={() => setDisableMessage(!disableMessage)}
              />
              Don&#39;t show this message again
            </label>
          }
          primary={
            <Button
              appearance="primary"
              link="discoup://launch"
              caption="Launch"
              onClick={savePreferences}
            />
          }
        />
      </div>
    </DiscoModal>
  )
}

export default BulkUploaderPage
